import Card from "../Card";
import ArticleHeader from "../ArticleHeader";
import Container from "../Container";
import Article from "../Article";
import { useTranslation } from "react-i18next";
import { formatBold } from "../../utils";

const Body = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Card>
        <ArticleHeader>
          <h1>{t("private_policy")}</h1>
          <span />
        </ArticleHeader>
        <Article>
          {[
            {
              title: t("term_title_1"),
              content: t("term_des_1"),
              contentChild: t("term_des_1_1"),
            },
            { title: t("term_title_2"), content: t("term_des_2") },
            { title: t("term_title_3"), content: t("term_des_3") },
            { title: t("term_title_4"), content: t("term_des_4") },
            { title: t("term_title_5"), content: t("term_des_5") },
            { title: t("term_title_6"), content: t("term_des_6") },
            { title: t("term_title_7"), content: t("term_des_7") },
            { title: t("term_title_8"), content: t("term_des_8") },
          ].map((item, index) => {
            return (
              <div key={index}>
                <h2>{item.title}</h2>
                {item.content.split("\n").map((content, contentIndex) => {
                  return <p key={contentIndex}>{content}</p>;
                })}

                {index === 0 && (
                  <div>
                    {[
                      { title: t("collect_1") },
                      { title: t("collect_2") },
                      { title: t("collect_3") },
                      { title: t("collect_4") },
                      { title: t("collect_5") },
                      { title: t("collect_6") },
                      { title: t("collect_7") },
                      { title: t("collect_8") },
                    ].map((item, index) => {
                      return (
                        <div
                          className="row"
                          style={{ alignItems: "center" }}
                          key={index}>
                          <div
                            style={{
                              width: 10,
                              height: 10,
                              backgroundColor: "#bbb",
                              borderRadius: "25",
                            }}
                          />
                          <p
                            style={{
                              margin: 0,
                              paddingLeft: 10,
                            }}>
                            {item.title}
                          </p>
                        </div>
                      );
                    })}
                    <p>
                      {item.contentChild?.split("\n").map((item, index) => {
                        return <p key={index}>{formatBold(item)}</p>;
                      })}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </Article>
      </Card>
    </Container>
  );
};

export default Body;
